import i18next, { ReadCallback } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next';

const localeLoaders = import.meta.glob<{ default: Record<string, unknown> }>(
  '../../../static/locales/*/*.json'
);

const localePath = (language: string, namespace: string) =>
  `../../../static/locales/${language}/${namespace}.json`;

i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend(
      (language: string, namespace: string, callback: ReadCallback) => {
        const load = localeLoaders[localePath(language, namespace)];

        if (!load) {
          callback(
            new Error(`i18n: missing locale ${language}/${namespace}`),
            null
          );
          return;
        }

        load()
          .then(({ default: resources }) => {
            callback(null, resources);
          })
          .catch(error => {
            callback(error, null);
          });
      }
    )
  )
  .init({
    fallbackLng: 'en',
    lng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
  });

export { i18next as i18n };
